"use client";
import Marquee from "react-fast-marquee";
import React from "react";
import { MarqueeItem } from "@/ui/CryptoNavBar/MarqueeItem";
interface CryptoNavBar {
  data: CryptoType[] | null;
}

export const CryptoNavBar: React.FC<CryptoNavBar> = (T) => {
  return (
    <section
      className={`h-[40px] crypto-navbar justify-center sticky left-0 right-0 top-0  z-40 bg-black overflow-x-hidden translate-y-0 flex items-center cursor-pointer transition-all duration-300`}
    >
      <Marquee pauseOnHover>
        {T.data &&
          T.data.map((crypto: CryptoType) => {
            return <MarqueeItem crypto={crypto} key={crypto.id} />;
          })}
      </Marquee>
    </section>
  );
};
